import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import productReducer from './slices/product';
import { emailVerificationSlice } from './slices/emailverification';
import distanceReducer from './slices/distance';
// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

export const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  verification: emailVerificationSlice.reducer,
  product: persistReducer(productPersistConfig, productReducer),
  distance: distanceReducer,
});

export default rootReducer;
